import { LayoutGrid } from 'lucide-react';
import { FiLink, FiMapPin, FiMessageSquare } from 'react-icons/fi';

export const WHATSAPP_BASE = '/nyafaz-ep/workspace/whatsapp';

const WORKSPACE_BASE = '/nyafaz-ep/workspace';

export function isWorkspaceWhatsAppPath(pathname) {
  const p = String(pathname || '');
  return p === WHATSAPP_BASE || p.startsWith(`${WHATSAPP_BASE}/`);
}

export function buildWorkspaceWhatsAppSidebarItems() {
  const items = [
    { segment: 'messages', label: 'Visit messages', IconComponent: FiMessageSquare },
    { segment: 'accounts', label: 'Accounts', IconComponent: FiLink },
    { segment: 'branches', label: 'Branches', IconComponent: FiMapPin },
  ];
  return [
    {
      key: 'overview',
      sectionId: 'overview',
      IconComponent: LayoutGrid,
      label: 'Back to main',
      to: `${WORKSPACE_BASE}/overview`,
    },
    ...items.map((item) => {
      const to = `${WHATSAPP_BASE}/${item.segment}`;
      return {
        key: `whatsapp-${item.segment}`,
        sectionId: 'whatsapp',
        IconComponent: item.IconComponent,
        label: item.label,
        to,
        activeMatchPaths: [to, `${to}/`],
      };
    }),
  ];
}
